import { api } from './client'

export interface ZabbixHost {
  id: string
  name: string
  status: 'up' | 'down' | 'problem' | 'disabled'
  cpu_percent: number
  memory_percent: number
  disk_percent: number
  network_in_bps: number
  network_out_bps: number
}

export interface ZabbixProblem {
  id: string
  host: string
  name: string
  severity: string
  started_at: string
}

export interface ZabbixSummary {
  total_hosts: number
  hosts_up: number
  hosts_down: number
  hosts_disabled?: number
  problems_by_severity: Record<string, number>
}

export interface ZabbixMetrics {
  hosts: ZabbixHost[]
  problems: ZabbixProblem[]
  summary: ZabbixSummary
  collected_at: string
  is_stale: boolean
}

export interface ZabbixConfig {
  group_exists: boolean
  group_name: string
  enabled: boolean
  host_group_names?: string[]
}

export const zabbixApi = {
  getMetrics: (tenantId: number, hostId?: string) => {
    const params = hostId ? `?host_id=${hostId}` : ''
    return api.get<ZabbixMetrics>(`/v1/tenants/${tenantId}/zabbix/metrics${params}`).then(r => r.data)
  },

  getHosts: (tenantId: number) =>
    api.get<{ hosts: ZabbixHost[]; collected_at: string }>(`/v1/tenants/${tenantId}/zabbix/hosts`).then(r => r.data),

  refresh: (tenantId: number) =>
    api.post<ZabbixMetrics>(`/v1/tenants/${tenantId}/zabbix/refresh`).then(r => r.data),

  getConfig: (tenantId: number) =>
    api.get<ZabbixConfig>(`/v1/tenants/${tenantId}/zabbix/config`).then(r => r.data),

  updateConfig: (tenantId: number, data: { enabled: boolean }) =>
    api.put(`/v1/tenants/${tenantId}/zabbix/config`, data).then(r => r.data),

  deleteConfig: (tenantId: number) =>
    api.delete(`/v1/tenants/${tenantId}/zabbix/config`).then(r => r.data),
}
